export default "<app-cart>\n    <router-outlet></router-outlet>\n</app-cart>"